import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasRole } from "../lib/roles";

export const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0D12] text-slate-400 font-mono text-sm uppercase tracking-widest">
        Chargement...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !hasRole(user, ...roles)) return <Navigate to="/" replace />;
  return children;
};
